// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2TR1F","inputDescription":"styles_inputDescription__2cBeW"};